// extracted by mini-css-extract-plugin
export default {"job":"Job-module--job--7hhOF","details":"Job-module--details--Lsnii"};